export default __webpack_public_path__ + "locales/en/JavascriptSdk.json?hash=c16508a669992bed7ab982d382563b95";